<template>
    <div>
        
        <div class="row no-gutters py-2 mt-3 company-form-container-warapper">
            <div class="ibox col-md-12 border-0">
                <div class="ibox-title dashboard_title company-form-box-title">
                    <h4 class="clearfix">
                        <span class="">Provident Fund Member List
                            <span class="title-sub-text">
                            </span>
                        </span> 
                        <span class="float-right">
                            
                        </span>
                    </h4>
                </div>
                <div class="ibox-content pf-summery-data">
                    <b-overlay :show="showoverlay" rounded="sm" class='trustee-overlay'>
                    <div class="row py-3">
                       
                        
                        <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 loan_approve_list  front_member_list">
                            <common-list :action_btn_text="action_btn_text"   :is_approval_list="is_approval_list" :pageurl="this.$api_url" :is_action="0" :is_pf="is_n_pf" :checkbox="checkbox"  :appended_column="em_reg_appended_column" :key="em_reg_list_key" :company_options="em_reg_company_options" :employees="em_reg_custom_list" :default_column="em_reg_default_column" :primary_key="em_reg_primary_key" v-on:childToParent="reg_edit"></common-list>
                        </div>
                       
                    </div>
                    </b-overlay>
                </div>

            </div>
        </div>
        <b-modal  id="bv-modal-pf-details" hide-footer  title="Employee Profile" size="lg">
            <b-overlay rounded="sm">
                <div v-if="details.length == 0" class="px-3 py-3 no-result-cell text-center">
                    
                    <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
                <div  v-else>
                <div class="clearfix border rounded mt-3  py-2 mb-2 mr-3 mb-0 col-md-12">
                        <div class="row justify-content-center">
                            {{report_data.company_name}}
                        </div>
                        <div class="row justify-content-center">
                            {{report_data.title}}
                        </div>
                    </div>
                    <div class="clearfix border rounded mt-3 mb-2 mr-3 py-2 mb-0 col-md-12">
                        <div class="row justify-content-center mb-2">
                            Employee Information
                        </div>
                        <table class="table">
                            <tr>
                                <td class="2"> 
                                    Employee ID
                                </td>
                                <template v-if="employee_info.employee_code != ''">
                                    <td class="2 text-left">
                                        {{employee_info.employee_code}}
                                    </td>
                                </template> 
                                <template v-else>
                                    <td class="2 text-left">
                                        N/A
                                    </td>
                                </template>  
                                <td class="2">
                                    PF Membership Period
                                </td>
                                <td class="2 text-left">
                                    {{employee_info.PF_membership_period}}
                                </td>
                            </tr>
                            <tr>
                                <td class="2">
                                    Employee Name
                                </td>
                                <td class="2 text-left">
                                    {{employee_info.employee_name}}
                                </td>
                                <td class="2">
                                    Service Period
                                </td>
                                <td class="2 text-left">
                                    {{employee_info.service_period}}
                                </td>
                            </tr>
                            <tr>
                                <td class="2">
                                    Job Position
                                </td>
                                <td class="2 text-left">
                                    {{employee_info.jobposition}}
                                </td>
                                <td class="2">
                                    Opening Balance Of Fund
                                </td>
                                <td class="2 text-left">
                                    {{formatMoney(details.opening_balance)}}
                                </td>
                            </tr>
                            <tr>
                                <td class="2">
                                    Joining Date
                                </td>
                                <td class="2 text-left">
                                    {{employee_info.joining_date}}
                                </td>
                                <td class="2">
                                    Closing Balance Of Fund
                                </td>
                                <td class="2 text-left">
                                    {{formatMoney(employee_info.closing_balance_of_fund)}}
                                </td>
                            </tr>
                            <tr>
                                <td class="2">
                                    PF Enrollment Date
                                </td>
                                <td class="2 text-left">
                                    {{employee_info.PF_enrollment_date}}
                                </td>
                            </tr>
                            <template v-if="employee_info.PF_leave_date!='0000-00-00'">
                                <tr>
                                    <td class="2">
                                        PF Leave Date
                                    </td>
                                    <td class="2 text-left">
                                        {{employee_info.PF_leave_date}}
                                    </td>
                                </tr>
                            </template>
                        </table>
                    </div>
               
                </div>
                

            </b-overlay>
        </b-modal>
    </div>
</template>
<script>

    export default{
        mounted() {
            //if(this.employeedata.last_working_day == '0000-00-00')
                //this.fdata.last_working_day = '';
            
            this.showoverlay = false;
        },
        props: ['pageurl' , 'flg'],
        components: {
        },
        data(){            
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            const minDate = new Date(today);
            return {
                     
                cu:window.location.href,
                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                showoverlay : true,

                pf_start_date : '',
                errormsg:[],
				hide:false,
                checkbox:1, 
                download_button:1,

                show_loader:true,
                show_loader_2:true,
                show_loader_3:true,
                
                
                pf_del_id : 0,
                pgurl:this.$api_url, 
                /* start pf signup variables */
                per_page:20,
                application_lists: [],
                pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
                application_loading : false,
                employeesearch:{name:'',status:1},
                users : [], 
                em_tmp_custom_list:[],
                eligible_pf: 0,
                chosen_emp_id: 0,
                curr_emp_name: '',
                curr_emp_id: 0,
                curr_app_id: 0,
                last_payslip_date:'',
                pf_approve_date: '',
                min_date:minDate,
                pfoverlay : true,
                report_data : [],
                details : [],
                employee_info : [],
                is_approval_list:1,



                /**Child Component property data */

                
                is_action:0, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                list_key:0, /* Component Key */
                custom_list:[],  /* Data List */
                default_column:['name'], /* Default Column List */
                appended_column:[                 
                    { value: "reg_applied_date", text: "Application Date",type: "text"},
               
                ],                   /* Appended Column List  and there title and type */
                primary_key:'id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, 
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                company_options:[],         /* Company Filterable options */

                tmp_custom_list:[],

                custom_array:[],


                /***Child Component property data */





                /**Child Component property data */

                is_n_pf:1,
                reg_is_action:1, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                reg_list_key:0, /* Component Key */
                reg_custom_list:[],  /* Data List */
                reg_default_column:['name','email','employee_code'], /* Default Column List */
                reg_appended_column:[],                   /* Appended Column List  and there title and type */
                reg_primary_key:'employee_id',  /* Primary is the unique key of the list this key will be returned if the row is clicked, 
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/
                reg_company_options:[],         /* Company Filterable options */

                reg_tmp_custom_list:[],

                reg_custom_array:[],
                action_btn_text:'Details',
                    

                    
                em_reg_appended_column:[                 
                    { value: "pf_start", text: "PF Start Date",type: "date"},
                    { value: "pf_end", text: "PF End Date",type: "date"},
                ],       
                em_reg_tmp_custom_list:[],
                em_reg_company_options:[],
                em_reg_custom_list:[],
                em_reg_list_key:0, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                em_reg_list_key:0,
                em_reg_primary_key:'id',
                em_reg_default_column:['name','email','jobposition','branch'], /* Default Column List */
                em_selected: [],
                selected: [],


                /***Child Component property data */


                curr_update_id:'',
                curr_approve_date:'',
                curr_update_employee:'',

                
            }
        },
        methods:{
            formatMe(d)
            {
                return moment(d).format('DD/MM/YYYY');
            },
            
            pfGetRegisteredEmployees: function()
            {
                let currentObj = this;
                currentObj.show_loader = true;
                axios.get(this.$api_url+'/pf/employee/reglist-front' , {
    
                }).then(function(response){

                    
                this.em_reg_custom_list = [];



                if (typeof response.data.employee_data !== 'undefined')
                {
                    /* Assingning the list */ 
                    this.em_reg_tmp_custom_list = response.data.employee_data;
                    /* Assingning the list */ 
                    this.em_tmp_custom_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));
                }
                if (typeof response.data.options !== 'undefined')
                {
                    /* Assingning the Options */ 
                    this.em_reg_company_options = Object.keys(response.data.options).map((key) => (response.data.options[key]));
                }
                
                /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */
                
                if(this.em_tmp_custom_list.length > 0 )
                {
                    this.em_tmp_custom_list.forEach(element => {
                            if(element.employee_id > 0)
                            {
                                element.pf_total = this.formatMoney(element.pf_total);
                               
                                let last_payslip =  element.last_payslip;


                                if(element.pf_end != '0000-00-00' && last_payslip != null)
                                {
                                    
                                    const last_payslip_array = last_payslip.split('-');
                                    var last_payslip_date = new Date(last_payslip_array[0],last_payslip_array[1],0);


                                    let pf_end =  element.pf_end;
                                    const pf_end_array = pf_end.split('-');
                                    var pf_end_date = new Date(pf_end_array[0],pf_end_array[1]-1,pf_end_array[2]);
                                    var pf_end_month = pf_end_date.getMonth() + 1;
                                    var pf_end_year = pf_end_date.getFullYear();
                                    
                                    // if (cur_month >= pf_end_month && cur_year == pf_end_year) {
                                    
                                        
                                    if(last_payslip_date.getTime() >= pf_end_date.getTime())
                                    {
                                            /*  If DropDown type one is First Choice */
                                        element.status = 'Unsettled';

                                    }

                                }
                                if(element.pf_end == '0000-00-00')
                                {
                                    element.pf_end ='';
                                }
                                /* If DropDown type one is Second Choice */
                               
                                /* Action for all column **/

                            }
                        });


                this.em_reg_custom_list = this.em_tmp_custom_list;
                
                if(this.em_reg_custom_list.length > 0)
                {
                 
                    
                }
            }
            else
            {
                this.blankmsg = "No employee found as leaver";
            }
            
            
            this.em_reg_list_key = this.list_key + 1;
            currentObj.show_loader = false;
            
            }.bind(this)).catch(function (error){
                currentObj.show_loader = false;
                console.log(error);
                currentObj.serverError(error);
                
                });
            },
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     { 
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         } 

            //     }
                 
            //     return money;
            // }, 
            pfDetailsNew: function(employee_id)
            { 
                if(employee_id>0){
                let currentObj = this;
                
                let formData = new FormData();
                formData.append('employee_id', employee_id); 
                formData.append('viewmode', 1);
                formData.append('d_type', 'excel'); 
                this.pfoverlay = true;
                this.report_data = [];
                this.details = [];
                this.employee_info = [];
                
                axios.post(this.$api_url + '/pf/report/profile', formData)
                                    .then(function (response) 
                                    {
                                        this.report_data = response.data.file_name;
                                        this.employee_info = response.data.file_name.employee_info;
                                        this.details = response.data.file_name.data;
                                        this.pfoverlay = true;
                                    }.bind(this))
                                    .catch(function (error) 
                                    {
                                        console.log(error);
                                    }); 

                    }

                    this.$bvModal.show('bv-modal-pf-details');

            },
            reg_edit:function(data)
            {
                console.log(data);
                if(data.selected.length > 0)
                {
                    this.selected = data.selected;
                }
                else
                {
                    this.selected = [];
                }

                if(data.id && data.action_id==0)
                {
					this.pfDetailsNew(data.employee_id);
                }
            },
            download_file(fileURL) 
            {
                if(!this.checkNet()) return false;
                
                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }    
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            massExport: function()
            {
                if(this.selected == '')
                {
                    this.$bvToast.toast("No employee selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                }
                else
                {
                    this.showoverlay = false;
                    if(!this.checkNet()) return false;
                   
                    let url = ''
                    
                    url = this.$api_url + '/pf/report/summery';
            
                    let formData = new FormData();
                    formData.append('employee_ids', this.selected);
                
                    let currentObj = this;
                    axios.post(url, formData).then(function (response) 
                    {
                        var fileURL = response.data;
                        this.download_file(fileURL);
                        this.showoverlay = false; 
                        
                    }.bind(this))
                    .catch(error => {
                        if(error.response){
                            
                            this.showoverlay = false;
                            console.log(error.response);
                        }
                    });
                    return false;
                }

            },
           
            

        },
        created: function(){
            if(!this.checkNet()) return false;
            this.$validator.reset();
            this.pfGetRegisteredEmployees();
        } 
    }
</script> 